class Base {
    data = [];
}

export default Base;